import { defineStore } from 'pinia'
import { getInfo } from '@/api/system/rbac';

const UserStore = defineStore('user', {
  state: () => {
    return {
      userInfo: <Record<string, any>>{}
    }
  },
  getters: {
    permissions(state) {
      const result: any = {};
      (state.userInfo.permissions || []).forEach((element: Record<string, any>) => {
        result[element.permission] = element.actions;
      });
      return result;
    },
  },
  actions: {
    async getUserInfo() {
      // @mark
      const result = await getInfo();
//       const result={

//         "uid": "qxz2ow8",
//         "username": "jie1(Mock)",
//         "permissions": [
//             {
//                 "permission": "fta-pre-audit-relation-part",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "fta-pre-audit-relation-part-history",
//                 "actions": [
//                     "export",
//                     "query",
//                     "Detail"
//                 ]
//             },
//             {
//                 "permission": "echop-stamp-position-config",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "add",
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "echop-export-document-upload-log",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "dppqconfig",
//                 "actions": [
//                     "import",
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "echop-danger-package-stamping",
//                 "actions": [
//                     "query",
//                     "delete",
//                     "downloadOriginalFile",
//                     "downloadOriginalFileByArchived",
//                     "downloadStampedFileByArchived",
//                     "editFileByStamped",
//                     "downloadOriginalFileByStamped",
//                     "downloadStampedFileByStamped",
//                     "stampApply",
//                     "getStampFile",
//                     "upload",
//                     "editFile",
//                     "deleteByStamped",
//                     "batchArchived"
//                 ]
//             },
//             {
//                 "permission": "tjp-interface-data-head",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "sys-log",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-country-invoice",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "fta-pre-audit-info-management",
//                 "actions": [
//                     "Detail",
//                     "getNewRecommendedPartNumber",
//                     "updateRecommendedPartNumber",
//                     "sendPreAuditNotice",
//                     "saveswApplicationNumber",
//                     "checkPreAuditConfirm",
//                     "checkBatchPreAuditConfirm",
//                     "PreAuditConfirm",
//                     "export",
//                     "getFileList",
//                     "downloadFile",
//                     "getFileStream",
//                     "delete",
//                     "query",
//                     "partNameHsCodeChange",
//                     "upload",
//                     "checkSwApplicationNumberIsExist",
//                     "findBySwApplicationNumber"
//                 ]
//             },
//             {
//                 "permission": "dict",
//                 "actions": [
//                     "query",
//                     "add",
//                     "edit",
//                     "delete"
//                 ]
//             },
//             {
//                 "permission": "fta-pre-audit-info-management-history",
//                 "actions": [
//                     "getFileList",
//                     "query",
//                     "Detail"
//                 ]
//             },
//             {
//                 "permission": "port-lin",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "filemg",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "upload",
//                     "download"
//                 ]
//             },
//             // {
//             //     "permission": "dpFileUpload",
//             //     "actions": [
//             //         "edit",
//             //         "delete",
//             //         "add",
//             //         "export",
//             //         "query",
//             //         "seeFiles",
//             //         "download",
//             //         "upload",
//             //         "deleteFile",
//             //         "import",
//             //         "upFile"
//             //     ]
//             // },
//             // {
//             //     "permission": "tocq",
//             //     "actions": [
//             //         "edit",
//             //         "delete",
//             //         "add",
//             //         "query",
//             //         "import",
//             //         "deleteFile",
//             //         "upload",
//             //         "download"
//             //     ]
//             // },
//             {
//                 "permission": "declare-origin-country-other-company",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-template",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-country-list",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "sys-appoint-user",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "fta-part-management",
//                 "actions": [
//                     "GeneratePreview",
//                     "coverList",
//                     "importHsCodeList",
//                     "setPartStauts",
//                     "getBomNotice",
//                     "sendBomNoticeEmail",
//                     "PartsSync",
//                     "query",
//                     "import",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "fta-review-bom",
//                 "actions": [
//                     "export",
//                     "query",
//                     "generateReviewData",
//                     "getBomHasChanges"
//                 ]
//             },
//             {
//                 "permission": "job-Manager",
//                 "actions": [
//                     "query",
//                     "add",
//                     "edit",
//                     "delete"
//                 ]
//             },
//             {
//                 "permission": "fta-parts-bom",
//                 "actions": [
//                     "export",
//                     "detail",
//                     "query",
//                     "delete",
//                     "confirm",
//                     "import",
//                     "selfCheck",
//                     "checkBomIsExist"
//                 ]
//             },
//             {
//                 "permission": "exemption_info",
//                 "actions": [
//                     "edit",
//                     "query",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "unit",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "fta-report-edi-upload-fail-detail",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "fta-review-results-details",
//                 "actions": [
//                     "threeReviewComplete",
//                     "updateIsOrigin",
//                     "export",
//                     "query",
//                     "oneReviewComplete",
//                     "import",
//                     "getPartners",
//                     "clearSecStepRedisKey"
//                 ]
//             },
//             {
//                 "permission": "sys-north-client",
//                 "actions": [
//                     "edit",
//                     "query",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "echop-re-import-document-stamping",
//                 "actions": [
//                     "batchSendStampApply",
//                     "batchGetStampFiles",
//                     "sendStampApply",
//                     "fileUpdate",
//                     "updateBlNo",
//                     "batchArchive",
//                     "edit",
//                     "delete",
//                     "add",
//                     "sendReviewEmail",
//                     "upload",
//                     "query",
//                     "fileReview",
//                     "getStampFiles",
//                     "download"
//                 ]
//             },
//             {
//                 "permission": "fta-report-edi-upload-log",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             // {
//             //     "permission": "dpFileSearch",
//             //     "actions": [
//             //         "query",
//             //         "download"
//             //     ]
//             // },
//             {
//                 "permission": "asean-country",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "fta-report-basic-data-list",
//                 "actions": [
//                     "query",
//                     "coverAiPartNumberList",
//                     "importAiPartNumber"
//                 ]
//             },
//             {
//                 "permission": "fta-parts-bom-origin-declaration-document",
//                 "actions": [
//                     "download",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "echop-danger-package-stamping-batch",
//                 "actions": [
//                     "query",
//                     "delete",
//                     "upload",
//                     "downloadOriginalFile",
//                     "downloadStampedFile",
//                     "stampApply",
//                     "syncToDpCerts",
//                     "getStampFile"
//                 ]
//             },
//             {
//                 "permission": "role",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "echop-export-document-stamping",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "add",
//                     "query",
//                     "fileUpdate",
//                     "sendReviewEmail",
//                     "fileReview",
//                     "export",
//                     "batchArchive",
//                     "fileUploadCheck",
//                     "fileUpload",
//                     "sendStampApply",
//                     "getStampFiles"
//                 ]
//             },
//             {
//                 "permission": "dpEPart",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "add",
//                     "export",
//                     "query",
//                     "import",
//                     "download",
//                     "upload",
//                     "deleteFile"
//                 ]
//             },
//             {
//                 "permission": "fta-spot-check-ledger",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "add",
//                     "export",
//                     "query",
//                     "deleteFile",
//                     "upload",
//                     "getFileList",
//                     "downloadFile",
//                     "getFileStream",
//                     "getPartners"
//                 ]
//             },
//             {
//                 "permission": "declare-origincountry-change",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-declaration-doc",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add",
//                     "upload",
//                     "deleteFile"
//                 ]
//             },
//             {
//                 "permission": "exchange-rate",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "fta",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-country-doc-file",
//                 "actions": [
//                     "query",
//                     "deleteFile",
//                     "upload",
//                     "download",
//                     "BATCH_DOWNLOAD"
//                 ]
//             },
//             {
//                 "permission": "tjp-interface-data-list",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "fta-receipt",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "sys-interface-config",
//                 "actions": [
//                     "edit",
//                     "query",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "audit",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "transf",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "department",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "echop-re-import-review-ledger",
//                 "actions": [
//                     "query",
//                     "export"
//                 ]
//             },
//             {
//                 "permission": "fta-review-frequency-setting",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             // {
//             //     "permission": "ledger",
//             //     "actions": [
//             //         "query",
//             //         "edit",
//             //         "import",
//             //         "delete",
//             //         "add"
//             //     ]
//             // },
//             {
//                 "permission": "fta-parts-bom-file",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             // {
//             //     "permission": "dpInspledger",
//             //     "actions": [
//             //         "edit",
//             //         "export",
//             //         "query",
//             //         "download",
//             //         "upload",
//             //         "sendNotice",
//             //         "deleteFile"
//             //     ]
//             // },
//             {
//                 "permission": "rack",
//                 "actions": [
//                     "edit",
//                     "query",
//                     "delete",
//                     "add",
//                     "export",
//                     "import",
//                     "upload"
//                 ]
//             },
//             {
//                 "permission": "sys-doc",
//                 "actions": [
//                     "delete",
//                     "query",
//                     "download",
//                     "upload"
//                 ]
//             },
//             {
//                 "permission": "dpFReport",
//                 "actions": [
//                     "export",
//                     "query",
//                     "download",
//                     "upload",
//                     "deleteFile"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-country-head",
//                 "actions": [
//                     "coverList",
//                     "importTrackingNumber",
//                     "delete",
//                     "query",
//                     "add",
//                     "import",
//                     "DATA_CONFIRM",
//                     "export",
//                     "DOWNLOAD_TEMPLATE",
//                     "DECLARE",
//                     "declarationOfOriginUpload"
//                 ]
//             },
//             {
//                 "permission": "permission",
//                 "actions": [
//                     "synchronize",
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "sys-scheduled-mail",
//                 "actions": [
//                     "query",
//                     "emailAttachments"
//                 ]
//             },
//             {
//                 "permission": "echop-export-review-ledger",
//                 "actions": [
//                     "query",
//                     "export"
//                 ]
//             },
//             // {
//             //     "permission": "dpGoodsCert",
//             //     "actions": [
//             //         "query",
//             //         "delete",
//             //         "export",
//             //         "import",
//             //         "detail",
//             //         "downloadFiles",
//             //         "upLoadFile",
//             //         "getFiles",
//             //         "deleteFile",
//             //         "Conformity",
//             //         "CompletionNotice",
//             //         "dpCertDecNotice",
//             //         "DataConfirm",
//             //         "FactoryReportSec",
//             //         "FactoryReportOne",
//             //         "uploadGoodsCert",
//             //         "SendBcs",
//             //         "uploadStampFile"
//             //     ]
//             // },
//             {
//                 "permission": "echop-export-document-upload-fail-detail",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             // {
//             //     "permission": "dpShipNotice",
//             //     "actions": [
//             //         "delete",
//             //         "export",
//             //         "query",
//             //         "import",
//             //         "dataConfirm",
//             //         "dataConfirmResult"
//             //     ]
//             // },
//             {
//                 "permission": "trade",
//                 "actions": [
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "partners",
//                 "actions": [
//                     "import",
//                     "edit",
//                     "delete",
//                     "add",
//                     "query"
//                 ]
//             },
//             {
//                 "permission": "fta-report-basic-data-head",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "findById",
//                     "coverBolNoList",
//                     "coverSigniIdList",
//                     "importSignId",
//                     "importBolNo",
//                     "ediUpload",
//                     "generateOriginCertificate"
//                 ]
//             },
//             {
//                 "permission": "echop-export-document-stamping-info",
//                 "actions": [
//                     "query",
//                     "download",
//                     "export",
//                     "sendStampApply",
//                     "getStampFiles"
//                 ]
//             },
//             // {
//             //     "permission": "pdoc",
//             //     "actions": [
//             //         "edit",
//             //         "delete",
//             //         "query",
//             //         "import",
//             //         "export",
//             //         "download",
//             //         "upload",
//             //         "maintenance",
//             //         "deleteFile"
//             //     ]
//             // },
//             {
//                 "permission": "delegation",
//                 "actions": [
//                     "query",
//                     "edit",
//                     "add",
//                     "delete"
//                 ]
//             },
//             {
//                 "permission": "user",
//                 "actions": [
//                     "query",
//                     "import",
//                     "export",
//                     "edit",
//                     "delete",
//                     "add"
//                 ]
//             },
//             {
//                 "permission": "declare-origin-template-type",
//                 "actions": [
//                     "edit",
//                     "delete",
//                     "query",
//                     "add",
//                     "templatetTypeList"
//                 ]
//             }
//         ],
//         "delegator": []

// }
//       console.log(result)
      // 通知模块是一定有权限的
      const notification = {
        permission: 'notification',
        actions: ['query']
      }
      result.permissions.push(notification)
      this.userInfo = result
    }

  }
})


export default UserStore;
